import { render, staticRenderFns } from "./SoTienMat.vue?vue&type=template&id=48d5fa34"
import script from "./SoTienMat.vue?vue&type=script&lang=js"
export * from "./SoTienMat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports